import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './style';
import { Label } from 'components';
import { ReactComponent as GrayArrow } from 'assets/img/common/ic_right_arrow_gray.svg';

export interface Props {
    title?: string;
    contents: string;
    href?: string;
    onClickHandler?: () => void;
}

function ItemInfoBtn({ title, contents, href, onClickHandler }: Props): React.ReactElement {
    const history = useHistory();
    const onClickCallback = useCallback(
        (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (href) {
                history.push(href);
            } else {
                if (onClickHandler) onClickHandler();
            }
        },
        [history, href, onClickHandler]
    );

    return (
        <S.ItemInfoBtn isPointer={onClickHandler || href ? true : false} onClick={onClickCallback}>
            <S.InfoWrapper>
                {title ? <Label color={'gray_opacity_600'} fontStyle={'subtitle'} contents={title} /> : null}
                <Label color={'gray_opacity_800'} fontStyle={'body2'} contents={contents} />
            </S.InfoWrapper>
            {href || onClickHandler ? <GrayArrow /> : null}
        </S.ItemInfoBtn>
    );
}

export default ItemInfoBtn;
